import {
	IGetScheduledPushInfo,
	ICreateScheduledPush,
	IEditScheduledPush,
	IGetPaginatedScheduledPushes,
	IScheduledPushes,
} from 'types';
import { AxiosResponse } from 'axios';
import { request } from '../index';

const serviceGetScheduledPushInfo = (pushID: string): Promise<IGetScheduledPushInfo> => {
	return request({ typeOfRequest: 'getWithToken', url: `/api/v1/scheduled-push-notifications/${pushID}` });
};

const serviceCreateScheduledPush = (data: ICreateScheduledPush): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/v1/scheduled-push-notifications`, data });
};

const serviceEditScheduledPush = (data: IEditScheduledPush): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'putWithToken', url: `/api/v1/scheduled-push-notifications`, data });
};

const serviceGetPaginatedScheduledPushes = (
	args: IGetPaginatedScheduledPushes,
): Promise<AxiosResponse<IScheduledPushes>> => {
	return request({
		typeOfRequest: 'postWithToken',
		url: `/api/v1/scheduled-push-notifications/filtered`,
		data: args,
	});
};

const serviceDeleteScheduledPush = (pushID: string): Promise<AxiosResponse<void>> => {
	return request({
		typeOfRequest: 'deleteWithTokenAndWithParameterInUrlLine',
		url: `/api/v1/scheduled-push-notifications/${pushID}`,
	});
};

export {
	serviceGetScheduledPushInfo,
	serviceCreateScheduledPush,
	serviceEditScheduledPush,
	serviceGetPaginatedScheduledPushes,
	serviceDeleteScheduledPush,
};
